import { getArchive, getGlobals } from "storyblok/api"
import { getAllArchiveNewsCategories, getCategoryArchiveNewsItems } from "storyblok/inTheNews"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import InTheNewsCard from "components/InTheNewsCard"
import Meta from "components/Meta"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { getCategoryArchiveNewsItemsApi } from "storyblok/inTheNewsApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function InTheNewsArchive({ story, items, categories, meta, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-ignore="all">
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "In the News", href: "/in-the-news" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/in-the-news"
          categoryLinkPrefix="/in-the-news/category/"
          currentTab={{ name: "All", value: "all" }}
          list={<CardListSection
            key="all"
            items={items}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            columns={3}
            handler={(params) => getCategoryArchiveNewsItemsApi(params)}
            Card={InTheNewsCard} />}
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const categories = await getAllArchiveNewsCategories()
  const { items, currentPage, total, perPage } = await getCategoryArchiveNewsItems()
  const story = await getArchive("in-the-news", preview)

  return {
    props: {
      story: story ?? null,
      items: items ?? null,
      perPage,
      total,
      currentPage,
      categories: categories ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
